import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy'
})
export class SortByPipe implements PipeTransform {
  public transform(objects: Array<any>, key: string, order = 'ascending') {
    let val = 1;
    if (order === 'descending') {
      val = -1;
    }
    if (!Array.isArray(objects)) {
      return objects;
    }

    return [...objects].sort((prev, next) => {
      // Drill down to specified key - e.g. 'foo.bar.baz' = prev['foo']['bar']['baz']
      let a = key.split('.').reduce((d, k) => d[k], prev);
      let b = key.split('.').reduce((d, k) => d[k], next);
      if (a > b) {
        return val;
      } else if (a < b) {
        return -val;
      }
      return 0;
    });
  }
}
